import { AnalystTableSpec } from '@digital-twins/shared-types'
import { useTranslation } from 'react-i18next'

import { Text } from '@/components/ui/Text'
import { analystExhibitFrameClassName } from '@/features/studies/report/page/components/tabs/AnalystTab/analystExhibitFrame'
import { AnalystPlot } from '@/features/studies/report/page/components/tabs/AnalystTab/AnalystPlot'
import { AnalystTable } from '@/features/studies/report/page/components/tabs/AnalystTab/AnalystTable'
import { analystLegacyPlotLabels } from '@/features/studies/report/page/components/tabs/AnalystTab/legacy/analystLegacyPlotLabels'
import { analystTablePlot } from '@/features/studies/report/page/components/tabs/AnalystTab/legacy/analystTableAdapters'

import { routeAnalystTable } from './featuredPlotRouting'

interface FeaturedAnalystTableProps {
  table: AnalystTableSpec
  index: number
}

export function FeaturedAnalystTable(props: FeaturedAnalystTableProps) {
  const { table, index } = props

  const { t } = useTranslation('app')
  const decision = routeAnalystTable(table)

  if (decision.renderer === 'text') {
    return (
      <div
        className="rounded-xl border border-border bg-muted/40 p-4"
        data-testid={`thread-featured-table-invalid-${index}`}
      >
        <Text size="sm" color="muted">
          {t('studyReport.analyst.tableInvalid')}
        </Text>
      </div>
    )
  }

  // A dense table draws Python's heat grid, else the stored read; a table
  // the read cannot scale stays a table.
  const drawn =
    decision.renderer === 'analyst_plot'
      ? analystTablePlot(table, analystLegacyPlotLabels(t))
      : null

  if (drawn) {
    return (
      <figure
        className={analystExhibitFrameClassName('inline')}
        data-testid={`thread-featured-table-${index}`}
      >
        <figcaption className="flex flex-col gap-1">
          <Text size="base" weight="semibold">{table.title}</Text>
          {table.subtitle ? (
            <Text size="xs" color="muted">
              {table.subtitle}
            </Text>
          ) : null}
        </figcaption>
        <div className="mt-4 min-h-0" data-testid={`thread-featured-table-exhibit-${index}`}>
          <AnalystPlot
            plot={drawn.plot}
            index={index}
            isLegacy={drawn.isLegacy}
            testIdScope="thread-featured-table"
          />
        </div>
      </figure>
    )
  }

  return (
    <div data-testid={`thread-featured-table-analyst-${index}`}>
      <AnalystTable table={table} index={index} appearance="inline" />
    </div>
  )
}
